import React from "react";
import "./Why_Choose_Us.css";
import { Row, Col } from "react-bootstrap";
import Pulse_Circle_Lottie from "../../animation/pulse_circle_lottie/Pulse_Circle_Lottie";
const Why_Choose_Us = () => {
  const leftPoints = [
    {
      number: "01",
      title: "All-in-One App",
      text: "Book rides, transport goods or share taxi, all in one place.",
    },
    {
      number: "02",
      title: "Fast & Easy Booking",
      text: "Get moving in just a few taps.",
    },
    {
      number: "03",
      title: "Trusted Drivers",
      text: "Verified professionals for safe, reliable service.",
    },
  ];

  const rightPoints = [
    {
      number: "04",
      title: "Real-Time Tracking",
      text: "Track every ride or delivery live.",
    },
    {
      number: "05",
      title: "Transparent Pricing",
      text: "No hidden fees — just fair, upfront fares.",
    },
    {
      number: "06",
      title: "24 × 365 Availability",
      text: "We’re ready whenever you need us.",
    },
  ];

  return (
    <section className="why-section">
      <div className="container">
        <h2 className="why-title">Why Choose Us ?</h2>
        <p className="why-subtitle">
          Because you deserve fast, safe, & reliable rides anytime, anywhere
        </p>

        <Row className="align-items-center justify-content-center why-wrapper">
          <Col lg={4} md={4} sm={12} className="why-left">
            {leftPoints.map((item, i) => (
              <div className="why-item" key={i}>
                <h3 className="why-number">{item.number}</h3>
                <h4 className="why-heading">{item.title}</h4>
                <p className="why-text">{item.text}</p>
              </div>
            ))}
          </Col>
          <Col lg={4} md={4} sm={12} className="text-center">
            <div className="middle_div">
              <div className="lottie_holder">
                <Pulse_Circle_Lottie />
              </div>

              <div className="why-phone">
                <img
                  src="/assets/images/home/why_choose_us/mobile.png"
                  alt="App Preview"
                  className="why-center-img"
                />
              </div>
            </div>
          </Col>
          <Col lg={4} md={4} sm={12} className="why-right">
            {rightPoints.map((item, i) => (
              <div className="why-item" key={i}>
                <h3 className="why-number">{item.number}</h3>
                <h4 className="why-heading">{item.title}</h4>
                <p className="why-text">{item.text}</p>
              </div>
            ))}
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Why_Choose_Us;
